import React from 'react';
import { createBrowserRouter, redirect } from 'react-router-dom';

const Deposit = React.lazy(() =>
  import('views/deposit').then((module) => ({
    default: module.Deposit,
  })),
);
const NotFound = React.lazy(() =>
  import('views/notFound').then((module) => ({
    default: module.NotFound,
  })),
);
const Payout = React.lazy(() =>
  import('views/payout').then((module) => ({
    default: module.Payout,
  })),
);
const Refund = React.lazy(() =>
  import('views/refund').then((module) => ({
    default: module.Refund,
  })),
);
const TopUp = React.lazy(() =>
  import('views/topUp').then((module) => ({
    default: module.TopUp,
  })),
);

const AppRouter = createBrowserRouter([
  {
    path: '/',
    element: null,
    loader: () => redirect('not-found'),
  },
  {
    path: 'deposit',
    element: <Deposit />,
  },
  {
    path: 'payout',
    element: <Payout />,
  },
  {
    path: 'refund',
    element: <Refund />,
  },
  {
    path: 'top-up',
    element: <TopUp />,
  },
  {
    path: 'not-found',
    element: <NotFound />,
  },
]);

export default AppRouter;
